import cn from 'classnames';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Avatar,
  Calendar,
  Description,
  ScheduleButton,
  Tags,
  useModeSwitch,
} from '@features/coaches';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
// import { FormatAlignCenter } from '@mui/icons-material';
import useHeaderMenu from '@src/library/hooks/header/useHeaderMenu';
import * as st from './styles.module.scss';

interface Props {
  id: number;
  isAnotherCoachBuy?: boolean;
  isCardRedirect?: boolean;
  isIndividualCoachCard?: boolean;
}

const modes = ['ON', 'OF'];

export const CoachCard: React.FC<Props> = ({
  id,
  isAnotherCoachBuy = true,
  isCardRedirect = true,
  isIndividualCoachCard = false,
}) => {
  const navigate = useNavigate();
  const { showMobile } = useHeaderMenu();
  const { code } = useParams<{ code: string }>();
  const { selectedMode, changeMode } = useModeSwitch();
  const { data: coach } = useCoachQuery({ id: String(id) });

  const onScheduleClick = (id: number) =>
    navigate(`/coaches/${code}/buy-schedule/${JSON.stringify({ id: id, mode: selectedMode })}`);

  const onCardClick = () => navigate(`/coaches/${code}/specialist/${id}`);

  return (
    <div
      className={cn(st.card)}
      onClick={() => {
        if (isCardRedirect) return onCardClick();
      }}
    >
      <div className={st.card__main}>
        <div className={st.card__avatar}>
          <Avatar id={id} isIndividualCoachCard={isIndividualCoachCard} />
        </div>
        <div className={st.card__infoContainer}>
          <div className={st.card__info}>
            {/*<Name id={id} isIndividualCoachCard={isIndividualCoachCard} />*/}
            <div>
              <Tags id={id} isIndividualCoachCard={isIndividualCoachCard} />
              {/* <Experience id={id} /> */}
            </div>
            {isAnotherCoachBuy && (
              <div className={st.card__buttons}>
                {modes.map((mode) => (
                  <ScheduleButton
                    key={mode}
                    mode={mode}
                    isActive={mode === selectedMode}
                    coachId={id}
                    onClick={(e) => {
                      e.stopPropagation();
                      changeMode(mode);
                    }}
                  />
                ))}
              </div>
            )}
            {isAnotherCoachBuy && showMobile && !isIndividualCoachCard && (
              <ScheduleButton
                key={selectedMode}
                mode={selectedMode}
                isActive={true}
                coachId={id}
                showMobile={showMobile}
              />
            )}
          </div>

          <div className={st.card__additionalInfo}>
            <div className={st.card__circle}>
              <span className={st.card__count}>4</span>
            </div>
            <span className={st.card__city}>Москва</span>
          </div>
        </div>
        <div className={st.card__schedule}>
          {isAnotherCoachBuy && (
            <Calendar
              mode={selectedMode}
              coachId={id}
              onClick={onScheduleClick}
              isIndividualCoachCard={isIndividualCoachCard}
            />
          )}
        </div>
      </div>

      {isIndividualCoachCard && coach?.description && (
        <div className={st.card__about}>
          <h4 className={st.card__aboutTitle}>Обо мне</h4>
          <Description id={id} isIndividualCoachCard={isIndividualCoachCard} />
        </div>
      )}
    </div>
  );
};
